__turbopack_context__.v({
  "call_icon": "Header-module-scss-module__REFuiq__call_icon",
  "call_react_icon": "Header-module-scss-module__REFuiq__call_react_icon",
  "contact_social_links": "Header-module-scss-module__REFuiq__contact_social_links",
  "drop_down_nav_link": "Header-module-scss-module__REFuiq__drop_down_nav_link",
  "dropdown": "Header-module-scss-module__REFuiq__dropdown",
  "dropdown_icon": "Header-module-scss-module__REFuiq__dropdown_icon",
  "dropdown_menu": "Header-module-scss-module__REFuiq__dropdown_menu",
  "header": "Header-module-scss-module__REFuiq__header",
  "header_bottom": "Header-module-scss-module__REFuiq__header_bottom",
  "header_container": "Header-module-scss-module__REFuiq__header_container",
  "header_flex": "Header-module-scss-module__REFuiq__header_flex",
  "header_locale_card": "Header-module-scss-module__REFuiq__header_locale_card",
  "header_locale_divider": "Header-module-scss-module__REFuiq__header_locale_divider",
  "header_locale_icon": "Header-module-scss-module__REFuiq__header_locale_icon",
  "header_locale_item": "Header-module-scss-module__REFuiq__header_locale_item",
  "header_locale_label": "Header-module-scss-module__REFuiq__header_locale_label",
  "header_right": "Header-module-scss-module__REFuiq__header_right",
  "header_right_btn": "Header-module-scss-module__REFuiq__header_right_btn",
  "header_toggle": "Header-module-scss-module__REFuiq__header_toggle",
  "header_trans": "Header-module-scss-module__REFuiq__header_trans",
  "icon": "Header-module-scss-module__REFuiq__icon",
  "logo": "Header-module-scss-module__REFuiq__logo",
  "mobile_header": "Header-module-scss-module__REFuiq__mobile_header",
  "mobile_header_div": "Header-module-scss-module__REFuiq__mobile_header_div",
  "mobile_logo": "Header-module-scss-module__REFuiq__mobile_logo",
  "nav_item": "Header-module-scss-module__REFuiq__nav_item",
  "nav_link": "Header-module-scss-module__REFuiq__nav_link",
  "navbar": "Header-module-scss-module__REFuiq__navbar",
  "navbar_brand": "Header-module-scss-module__REFuiq__navbar_brand",
  "navbar_cut_btn": "Header-module-scss-module__REFuiq__navbar_cut_btn",
  "navbar_nav": "Header-module-scss-module__REFuiq__navbar_nav",
  "res_header_links": "Header-module-scss-module__REFuiq__res_header_links",
});
